<template>
  <section class="about" id="about">
    <div class="container">
      <div class="about-content">
        <div class="about-text animate-slide-left">
          <h2 class="gradient-text">About Us</h2>
          <p>{{ aboutText1 }}</p>
          <p>{{ aboutText2 }}</p>
          <a href="#contact" class="cta-button btn-hover">Contact Us</a>
        </div>
        <div class="about-image img-hover animate-slide-right">🏢</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'About',
  props: {
    aboutText1: String,
    aboutText2: String
  }
}
</script>

<style scoped>
.about {
  padding: 6rem 2rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  position: relative;
}

.about::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="%232c5aa0" stroke-width="0.5" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
  opacity: 0.3;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.about-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5rem;
  align-items: center;
}

.about-text h2 {
  font-size: 3rem;
  margin-bottom: 2rem;
  color: #333;
  font-weight: 300;
  position: relative;
}

.about-text h2::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #2c5aa0, #4a7bc8);
  border-radius: 2px;
}

.about-text p {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 1.5rem;
  line-height: 1.8;
}

.about-text .cta-button {
  display: inline-block;
  background: linear-gradient(135deg, #2c5aa0, #4a7bc8);
  color: white;
  padding: 1rem 2.5rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(44, 90, 160, 0.2);
  margin-top: 1rem;
}

.about-text .cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 35px rgba(44, 90, 160, 0.3);
}

.about-image {
  height: 450px;
  background: linear-gradient(135deg, #2c5aa0, #4a7bc8);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8rem;
  color: white;
  position: relative;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(44, 90, 160, 0.2);
}

.about-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.about-image:hover::before {
  opacity: 1;
}

.gradient-text {
  background: linear-gradient(45deg, #2c5aa0, #4a7bc8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

@media (max-width: 768px) {
  .about {
    padding: 4rem 1rem;
  }
  
  .about-content {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
  
  .about-text h2 {
    font-size: 2.5rem;
  }
  
  .about-text p {
    font-size: 1.1rem;
  }
  
  .about-image {
    height: 350px;
    font-size: 6rem;
  }
}

@media (max-width: 480px) {
  .about-text h2 {
    font-size: 2rem;
  }
  
  .about-text p {
    font-size: 1rem;
  }
  
  .about-image {
    height: 280px;
    font-size: 5rem;
  }
}
</style> 